import * as Yup from 'yup'; 

import { firstLetterCapitalized, onlyChars } from 'components/Form/Helpers/Parsers'
import { isPostalCodeValid } from 'components/Form/Validations/PostalCodeValidation'
import { AutocompleteValues, FieldTypes, IFields, InputModes } from 'models/Form/FieldsModels'
import { getLocationsByPostalCodeOnBlur, saveCityToSessionStorageOnBlur } from 'components/Form/Helpers/OnBlurHandlers'
import { getCitySuggestions, getStreetSuggestions } from 'components/Form/Helpers/SuggestionsHandler'

export enum AddressInfoFieldsNames {
   PostalCode = 'PostalCode',
   City = 'City',
   Street = 'Street',
   HouseNumber = 'HouseNumber',
   ApartamentNumber = 'ApartamentNumber',
}

export const addressInfoFields: IFields = {
   [AddressInfoFieldsNames.PostalCode]: {
      name: AddressInfoFieldsNames.PostalCode,
      type: FieldTypes.string,
      label: "Kod Pocztowy",
      placeholder: "Twój kod",
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.PostalCode,
   
      visible: true,
      validation: Yup.string().test(isPostalCodeValid),
      mask: "99-999",
      onBlurHandler: getLocationsByPostalCodeOnBlur,
   },
   [AddressInfoFieldsNames.City]: {
      name: AddressInfoFieldsNames.City,
      type: FieldTypes.stringAutocomplet,
      label: "Miasto",
      placeholder: "Podaj miasto",

   
      inputMode: InputModes.text,
      browserAutocomplete:  AutocompleteValues.City,

      getOptionsFunction: getCitySuggestions,
      visible: true,
      maxLength: 40,
      parser: onlyChars,
      validation: Yup.string().required("Nieprawidłowa wartość"),
      onBlurHandler: saveCityToSessionStorageOnBlur,
   },
   [AddressInfoFieldsNames.Street]: {
      name: AddressInfoFieldsNames.Street,
      type: FieldTypes.stringAutocomplet,
      label: "Ulica",
      placeholder: "Podaj ulicę",
   
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.Street,

      getOptionsFunction: getStreetSuggestions,
      visible: true,
      maxLength: 50,
      parser: firstLetterCapitalized,
      validation: Yup.string().required('Nieprawidłowa wartość').min(2, 'Nieprawidłowa wartość'),
   },
   [AddressInfoFieldsNames.HouseNumber]: {
      name: AddressInfoFieldsNames.HouseNumber,
      type: FieldTypes.string,
      label: "Nr domu",
      placeholder: "Podaj numer domu",
      
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.HouseNumber,

      visible: true,
      maxLength: 10,
      validation: Yup.string().required('Nieprawidłowa wartość').max(10, 'Nieprawidłowa wartość')
   },
   [AddressInfoFieldsNames.ApartamentNumber]: {
      name: AddressInfoFieldsNames.ApartamentNumber,
      type: FieldTypes.string,
      label: "Nr mieszkania",
      placeholder: "Podaj numer mieszkania",
   
      inputMode: InputModes.text,
      browserAutocomplete: AutocompleteValues.ApartamentNumber,

      visible: true,
      maxLength: 10,
   },
}




